import { Component, Injector, Input, OnInit } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { UserModel } from '../../models/user.model';
import { UserRoleService } from '../../services/user-role.service';
import { ChassisFormHandler } from '../../../forms/form/classes/form-handler';
import { ListPluginOptions } from '../../../plugins/abstract-plugins/list/interfaces/list-plugin-options.interface';
import { RoleService } from '../../services/role.service';
import { trans } from '../../../localization/helpers';
import { LIST_PLUGIN_TYPE } from '../../../plugins/abstract-plugins/list/list-plugin-type';

@Component({
    selector: 'chassis-core-user-role-plugin',
    templateUrl: 'user-role.plugin.html',
    styleUrls: ['user-role.plugin.scss'],
    providers: [RoleService, UserRoleService]
})
export class UserRolePlugin implements OnInit {

    /**
     * Chassis form handler instance injected by the plugin slot, containing the form handler from the page.
     *
     * @type {ChassisFormHandler}
     */
    @Input() public form: ChassisFormHandler;

    /**
     * Observable containing the page's model instance.
     *
     * @type {Subject<any>}
     */
    @Input() public modelSubject: Subject<UserModel>;

    public options: ListPluginOptions;

    constructor(private injector: Injector) {
    }

    ngOnInit() {
        const service = this.injector.get(UserRoleService);

        this.modelSubject.subscribe((model) => {
            if (model.exists()) {
                service.params({
                    userId: model.id,
                });
            } else {
                this.form.success((data, resolve, reject) => {
                    service.params({
                        userId: data.id
                    });

                    resolve();
                });
            }
        });

        this.options = {
            type: LIST_PLUGIN_TYPE.ADD_REMOVE,
            title: trans('Roles'),
            service: service,
            columns: [{
                title: trans('Name'),
                name: 'display_name'
            }, {
                title: trans('Description'),
                name: 'description'
            }],
            modal: {
                titles: {
                    add: trans('Add role'),
                },
                form: {
                    service: this.injector.get(RoleService),
                    element: {
                        name: 'Role',
                        search: {
                            display: 'display_name'
                        }
                    },
                },
            },
            data: {
                model: this.modelSubject,
                form: this.form,
            },
            actions: {
                create: {
                    text: trans('Add a new user role')
                }
            }
        };
    }
}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/authentication/plugins/user-role/user-role.plugin.ts